import React from "react";
import App from "../../../pages/report/multiSelect";
import Field from "../../Common/Field/Field";
import Async from "react-select";

const BNumber = props => {
  return (
    <div class="row text-center">
      <div className="col-md-4 p-2 ml-auto" style={{ zIndex: "1000" }}>
        <label>Customer department</label>
        <App
          customerInfo={props.customerWithDepartment}
          selectedCustomers={props.storeCustomerData}
        />
      </div>
      <div className="col-md-4 p-1 mr-auto">
        <div className="col-md-6" style={{ padding: "8px 5px" }}>
          <label>BNumber</label>
          <Field
            inputType="text"
            inputName="bNumber"
            value={props.bNumber}
            style={{ height: "40px !important" }}
            onChange={props.updateState}
            disabled={false}
          // className="Select-control"
          />
        </div>
        <div className="col-md-6" style={{ padding: "8px 5px" }}>
          <label>Count & Construction</label>
          <Field
            inputType="text"
            inputName="countCons"
            value={props.countCons}
            style={{ height: "40px !important" }}
            onChange={props.updateState}
            disabled={false}
          // className="Select-control"
          />
        </div>
      </div>
    </div>
  );
};

export default BNumber;


// WEBPACK FOOTER //
// ./src/components/Report/forms/BNumber.js